import type { ContenidoAyuda } from "@/ui/AyudaVista";

/**
 * Ayuda de la Sala de cierre (solo el dueño). Antes no tenía Ayuda; lo que
 * había eran los `title` del botón «Analizar» y del 📌.
 */
export function ayudaSalaCierre(): ContenidoAyuda {
  return {
    intro: (
      <p>
        Un análisis con IA de cada ticket abierto, enfocado en cerrarlo: diagnóstico, qué se ha
        hecho, qué falta y el siguiente paso. Solo tú (el dueño) ves esta página.
      </p>
    ),
    secciones: [
      {
        titulo: "Qué hace cada botón",
        items: [
          {
            label: "Atorados",
            text: "Los casos abiertos que ya llevan en su estado actual más días que el límite de «quemado» de ese estado.",
          },
          { label: "Todos los abiertos", text: "Todos los casos que no están cerrados." },
          {
            label: "Marcados 📌",
            text: "Solo los que marcaste con 📌. Las marcas se guardan en este navegador: en otro equipo no salen.",
          },
          {
            label: "✨ Analizar (N nuevos)",
            text: "Corre la IA en los tickets de la lista que nunca se han analizado o que tuvieron movimiento desde su último análisis, hasta 6 por toque. Cada ticket se analiza así máximo una vez al día. Sale gris («Nada nuevo que analizar hoy») cuando no hay ninguno pendiente.",
          },
          { label: "📌", text: "Marca o desmarca el ticket para verlo en «Marcados»." },
          {
            label: "✨ Analizar este ticket / ↻ Re-analizar",
            text: "Analiza solo ese ticket en ese momento, aunque ya se haya analizado hoy.",
          },
          { label: "📋 Copiar", text: "Copia el análisis al portapapeles." },
          {
            label: <span className="font-mono text-accent-300">TE-…</span>,
            text: "Un TE resaltado dentro del análisis: tócalo para ir a ese caso.",
          },
          { label: "El TE o folio", text: "Tócalo para abrir el caso." },
        ],
      },
      {
        titulo: "Qué significa cada indicador",
        items: [
          { label: "sin análisis", text: "Ese ticket todavía no tiene análisis." },
          { label: "hay novedad", text: "El caso tuvo movimiento después de su último análisis: conviene volver a analizarlo." },
          { label: "al día", text: "El análisis ya considera lo último que pasó en el caso (o ya se analizó hoy)." },
          {
            label: "[🛠 nosotros / ⏳ cliente / 📦 proveedor]",
            text: "Quién tiene la pelota en ese caso.",
          },
          { label: "N d abierto · N d en estado", text: "Días desde que se creó el caso y días en su estado actual." },
        ],
      },
    ],
  };
}
